/**
 * A join code chosen for the *member* path, held across the Keycloak login
 * round-trip. The unified-join screen stores it, then reloads into the authed
 * app; the workspace gate redeems it once the user is signed in.
 */

const PENDING_KEY = 'vtak.pendingJoin';

/** The unified-join code in the URL (`?join=<code>`), or null. */
export function unifiedJoinCodeFromUrl(): string | null {
  return new URLSearchParams(window.location.search).get('join');
}

/** Remember a code to redeem as a member after login. */
export function storePendingJoin(code: string): void {
  window.localStorage.setItem(PENDING_KEY, code);
}

/** Read and clear the pending member-join code, if any. */
export function takePendingJoin(): string | null {
  const code = window.localStorage.getItem(PENDING_KEY);
  if (code) window.localStorage.removeItem(PENDING_KEY);
  return code;
}
